/* eslint-disable prettier/prettier */
/* eslint-disable no-use-before-define */
/* eslint-disable no-console */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-unused-vars */
import axios from 'axios';
import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useEffect,
  useState,
} from 'react';

import { Loading } from '../components/Common/Loading';
import { LOCAL_STORAGE } from '../constants/local-storage.constant';
import { SESSION_STORAGE } from '../constants/session-storage.constants';
import { getTokenFromUrl } from '../helpers/getTokenFromUrl';
import { getUser, login } from '../operations/auth';
import { User } from '../operations/auth/types';
import { api } from '../services/api';

type SignInCredentials = {
  email: string;
  password: string;
};

export type DesafioDoisFatores = {
  desafio: string;
  email: string;
  reenviar_em: number;
  expira_em_segundos: number;
};

// customers: tem mais de uma empresa e escolhe na tela. desafio: falta o
// código que foi por e-mail. Os dois nulos: entrou.
export type SignInResult = {
  customers?: User[];
  desafio?: DesafioDoisFatores;
};

type AuthContextType = {
  signIn: (credentials: SignInCredentials) => Promise<SignInResult>;
  concluirSignIn: (
    email: string,
    response: any,
    dispositivo?: string
  ) => Promise<SignInResult>;
  signOut: () => void;
  user: User | null;
  setUser: Dispatch<SetStateAction<User>>;
  isLoading: boolean;
  signInByApiToken: (token: string) => Promise<void>;
};

type AuthContextProviderProps = {
  children: ReactNode;
};

export const AuthContext = createContext({} as AuthContextType);

export function AuthContextProvider({ children }: AuthContextProviderProps) {
  const [user, setUser] = useState<User>({} as User);
  const [isLoading, setIsLoading] = useState(true);

  async function loadUser(apiToken: string, logo?: string) {
    localStorage.setItem(LOCAL_STORAGE.CUSTOMER_API_TOKEN, apiToken);
    if (logo) {
      localStorage.setItem(LOCAL_STORAGE.LOGO, logo);
    }
    api.defaults.headers.Authorization = `Bearer ${apiToken}`;

    setIsLoading(true);

    try {
      const userFromApi = await getUser();
      setUser(userFromApi);
      return userFromApi;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response?.status === 401) {
          signOut();
          window.location.assign(`/login?error=true`);
        }
      }
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    async function boot() {
      const tokenFromUrl = getTokenFromUrl();

      try {
        if (tokenFromUrl) {
          localStorage.setItem(LOCAL_STORAGE.IS_IMPERSONATE_ACCESS, 'true');
          await loadUser(tokenFromUrl);
        } else if (localStorage.getItem(LOCAL_STORAGE.CUSTOMER_API_TOKEN)) {
          await loadUser(
            localStorage.getItem(LOCAL_STORAGE.CUSTOMER_API_TOKEN) as string
          );
        }
      } finally {
        setIsLoading(false);
      }
    }

    boot();
  }, []);

  // Dispositivos que passaram pelo código e pediram para ser lembrados (30
  // dias), um por e-mail. O backend confere e ignora o que venceu.
  function lerDispositivos(): Record<string, string> {
    try {
      return JSON.parse(localStorage.getItem(LOCAL_STORAGE.DISPOSITIVOS) || '{}');
    } catch (error) {
      return {};
    }
  }

  function guardarDispositivo(email: string, token: string) {
    const dispositivos = lerDispositivos();
    dispositivos[email.toLowerCase()] = token;
    localStorage.setItem(LOCAL_STORAGE.DISPOSITIVOS, JSON.stringify(dispositivos));
  }

  async function signIn({ email, password }: SignInCredentials) {
    const response = await login(
      email,
      password,
      lerDispositivos()[email.toLowerCase()]
    );

    if (response.dois_fatores) {
      return { desafio: response as DesafioDoisFatores };
    }

    return concluirSignIn(email, response);
  }

  async function concluirSignIn(
    email: string,
    response: any,
    dispositivo?: string
  ): Promise<SignInResult> {
    if (dispositivo) {
      guardarDispositivo(email, dispositivo);
    }

    if (response.customers) {
      return { customers: response.customers };
    }

    if (response.api_token) {
      localStorage.removeItem(LOCAL_STORAGE.IS_IMPERSONATE_ACCESS);
      const loggedUser = await loadUser(response.api_token, response.logo);
      if (loggedUser && loggedUser.name === loggedUser.customer_name) {
        sessionStorage.setItem(
          SESSION_STORAGE.SHOW_INCOMPLETE_REGISTER_WARNING,
          '1'
        );
      }
    }

    return {};
  }

  async function signInByApiToken(token: string) {
    localStorage.removeItem(LOCAL_STORAGE.IS_IMPERSONATE_ACCESS);
    await loadUser(token);
  }

  function signOut() {
    localStorage.removeItem(LOCAL_STORAGE.CUSTOMER_API_TOKEN);
    localStorage.removeItem(LOCAL_STORAGE.IS_IMPERSONATE_ACCESS);
  }

  return (
    <AuthContext.Provider
      value={{ signIn, concluirSignIn, signOut, user, isLoading, signInByApiToken, setUser }}
    >
      <>
        <Loading isActive={isLoading} />
        {children}
      </>
    </AuthContext.Provider>
  );
}
